var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-sheet', {
    staticClass: "d-flex align-center justify-center primary--text font-weight-bold",
    attrs: {
      "color": "transparent",
      "height": "100%",
      "width": "100%"
    }
  }, [_c('v-img', {
    attrs: {
      "src": "https://media.eipl.org/site/images/site/404-transparent-primary.png",
      "contain": "",
      "height": "50vh",
      "width": "80vh"
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }